import React, { Component } from 'react';
import classname from 'classnames';
import { Modal, WingBlank, Toast } from 'antd-mobile';
import { getAwardRulesInfo, toCash, getAwardRulesInfoByMarketingId } from '../../../service/chat-service';
import ActivityShare from '../activityShare';

import tools from '../../../utils/tools';

import styles from './style.module.less';
import rewardBox from '../images/rewardBox.png';
import complete from '../images/complete.png';
import noActive from '../images/noActive.png';
import caozuo from '../images/caozuo.jpg';
// import wx from "weixin-js-sdk";
const { alert } = Modal;

class RewardRule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketingId: '',
      lastAmount: 0, // 最高奖励金额
      userBalance: 0, // 用户可提现金额
      // rewardRule: {}, // 转发奖励
      marketingSpreadModels: [], // 传播奖里
      marketingModelVo: { endDateTime: '' }, // 活动截至日期
      activityEndDate: true,
    };
  }

  componentDidMount() {
    const { href } = window.location;
    if (href.indexOf('timeStamp') <= -1) {
      window.location.href = `${href}&timeStamp=1`;
    }

    window.document.title = '奖励规则';

    this.getAwardRulesInfo();
  }

  // 活动结束
  judgeActivityOff = (endTime, status) => {
    if (!endTime) return this.setState({ activityEndDate: true });
    const localTimeStamp = new Date().getTime();
    if (endTime < localTimeStamp || status === 3) {
      Toast.show('活动已结束！', 2);
    } else {
      this.setState({ activityEndDate: false });
    }
    return true;
  }

  getAwardRulesInfo = async () => {
    const productId = tools.getQueryString('productId');
    const marketingId = tools.getQueryString('marketingId');
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
    const server = marketingId ? getAwardRulesInfoByMarketingId : getAwardRulesInfo;
    try {
      const rewardRule = await server(snsapiBaseOpenId, productId, marketingId);
      if (rewardRule.code === 10000) {
        if (rewardRule.data.marketingForwardModel) {
          rewardRule.data.marketingForwardModel.type = 'Forward';
          rewardRule.data.marketingSpreadModels.unshift(rewardRule.data.marketingForwardModel);
        }
        rewardRule.data.marketingSpreadModels.map((item1) => {
          const item = item1;
          if (item.type === 'Forward') {
            item.content = '转发此链接给到任意一个群聊，或发到朋友圈，即可获得';
          } else {
            item.content = `转发给你的好友，群聊，朋友圈等只要有${item.visitors}个人浏览，即可获得`;
          }
          return item;
        });

        this.setState(
          {
            // rewardRule: rewardRule.data.marketingForwardModel || {},
            marketingSpreadModels: rewardRule.data.marketingSpreadModels || [],
            lastAmount: rewardRule.data.lastAmount,
            userBalance: rewardRule.data.userBalance,
            marketingId: rewardRule.data.marketingId,
            marketingModelVo: rewardRule.data.marketingModelVo,
          },
          () => {
            this.judgeActivityOff(
              rewardRule.data.marketingModelVo.endDateTime,
              rewardRule.data.marketingModelVo.status,
            );
          },
        );
      } else {
        Toast.show(rewardRule.message);
      }
    } catch (e) {
      // console.log(e);
    }
  }

  // 提现
  toCash = () => {
    const { userBalance, marketingId } = this.state;
    // const amount = tools.regYuanToFen(this.state.userBalance, 100)
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
    if (userBalance > 0) {
      alert('提示', '确定将所有金额提现？', [
        {
          text: '取消',
          onPress: () => {
          // console.log('cancel')
          },
        },
        {
          text: '确定',
          onPress: async () => {
            try {
              const { code, message } = await toCash(snsapiBaseOpenId, marketingId, userBalance);
              Toast.info(message, 2);
              if (code === 10000) {
                this.getAwardRulesInfo();
              }
            } catch (e) {
              Toast.info(e.message, 2);
            }
          },
        },
      ]);
    } else {
      Toast.show('您还没有可提现金额！');
    }
  }

  // 传播转发 奖励
  renderDiscountList = () => {
    const { marketingSpreadModels } = this.state;
    return marketingSpreadModels.map((item, index) => {
      let itemStatus;
      if (item.status === '1') {
        itemStatus = complete;
      } else if (item.status === '2') {
        itemStatus = noActive;
      } else {
        itemStatus = '';
      }
      return (
        <div key={item.id} className={styles.explainBox}>
          <div
            className={
              item.status === '1' || item.status === '2' ? classname(styles.number, styles.noNumber) : styles.number
            }
          >
            {index + 1}
          </div>
          <div className={styles.explain}>
            {item.content}
            <div style={{ display: item.type === 'Forward' ? 'none' : 'block' }} className={styles.steps}>
              {item.endNum}
              {' '}
              /
              {item.visitors}
            </div>
          </div>
          <div
            className={
              item.status === '1' || item.status === '2'
                ? classname(styles.getAmount, styles.amountComplete)
                : styles.getAmount
            }
          >
            <img src={itemStatus} alt="" />
            <i>￥</i>
            {item.amount / 100}
          </div>
        </div>
      );
    });
  }

  render() {
    const {
      marketingModelVo, lastAmount, userBalance, activityEndDate,
    } = this.state;
    const { endDateTime } = marketingModelVo;
    return (
      <div className={styles.containerBox}>
        <div className={styles.rewardRuleBac}>
          <div className={styles.topCircle}>
            最高领
            {lastAmount / 100}
            元
          </div>
          <div className={styles.rewardRuleBox}>
            <img src={rewardBox} alt="rewardbox" />
            <div className={styles.amount}>
              <i>￥</i>
              <span>{userBalance / 100}</span>
            </div>
            <WingBlank size="lg">
              <div className={styles.pendingWithdrawal} onClick={this.toCash} role="button" tabIndex={0}>
                提现
              </div>
            </WingBlank>
            <div className={styles.pendingExplain}>立即参与下方任务，抢夺大红包</div>
          </div>
          {/* {this.renderMarketingForwardModel()} */}
          {this.renderDiscountList()}

          <div className={styles.activityExplain}>
            · 部分奖励所提及的填写资料，需由活动发布方确定信息真实有效后才能领取奖励
          </div>
          <div className={styles.activityExplain}>
            · 此次活动截止到：
            {activityEndDate ? '已结束' : tools.formatUnixtimestamp(endDateTime).split(' ')[0]}
            {/* {this.judgeActivityOff(endDateTime)} */}
          </div>
          <div className={styles.shareBox}>
            <div className={styles.itemTitle}>方式一：点击右上角按钮，分享此产品的链接</div>
            <div className={styles.itemBox}>
              <img style={{ width: '100%', height: '100%' }} src={caozuo} alt="" />
            </div>
            {/* <div className={styles.itemTitle}> */}
            {/* 方式二：长按保存下方海报图，分享海报 */}
            {/* </div> */}
            {/* <div className={styles.itemBox}> */}

            {/* </div> */}
            <div className={styles.itemTitle}>关注趣销销服务号，红包集满我们喊你提现</div>
            <div className={styles.itemBox}>
              <img src="http://lets-sell.oss-cn-beijing.aliyuncs.com/QUXIAOXIAO-PUBLICNUMBER.png" alt="" />
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.textCenter}>由趣销销提供技术支持</div>
          </div>
        </div>

        <ActivityShare />
      </div>
    );
  }
}

export default RewardRule;
